import { Routes } from '@angular/router';
import { configsMap, DOMAIN } from '../configurations/defaultConfigs';

export const SYSTEM_ROUTES: Routes = configsMap[DOMAIN]['routes'];
